const LRU = require('lru-cache')
const cachePage = new LRU({
  // 最大缓存数量
  max: 10,
  // 缓存过期时间(ms)
  maxAge: 1000 * 60 * 10
})

module.exports = cachePage
